<template>
  <div class="login-page">
    <div class="login">
      <div class="login-header">
        <img src="../assets/logo.svg" />
      </div>

      <p class="login-icone">
        <img src="../assets/login.png" />
      </p>

      <form @submit.prevent="Login" class="login-form">
        <input type="text" name="username" placeholder="Nome de usuário" v-model="username" required/>
        <input type="password" name="password" placeholder="Senha" v-model="password" required/>

        <button
          :class="button"
          type="submit"
          :disabled="isSubmitting"
        >
          <span v-if="isSubmitting" class="button-loading">
            <span class="button-spinner"></span>
            Entrando...
          </span>
          <span v-else>Entrar</span>
        </button>
      </form>
    </div>

    <div :class="loginAlert" :style="style">
      <span class="msg">Erro: Login incorreto</span>
      <div class="close-btn" v-on:click="closeAlert">
        <span class="fas ">x</span>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "LoginPage",
  beforeRouteEnter(to, from, next){
    to.meta.title = "PecSmart - Login";
    document.title = to.meta.title;
    next();
  },
  data() {
    return {
      username: '',
      password: '',
      loginAlert: 'alert hide',
      style: '',
      button: 'submit-button',
      isSubmitting: false,
    }
  },
  methods: {
    alert: function() {
      this.loginAlert = 'alert show showAlert'
      this.style = 'right: 20px;'
    },
    closeAlert: function() {
      this.loginAlert = 'alert hide'
      this.style = ''
    },

    async Login() {
      if (this.isSubmitting) return

      document.body.style.cursor = 'progress';
      this.isSubmitting = true
      this.button = "submit-button-disable"
      this.closeAlert()
      const user = {
        username: this.username,
        password: this.password
      }
      const isLoginPage = true
      await this.$store.dispatch("login", {user, isLoginPage})
      if (this.$store.getters.getError) {
        this.alert()
      }
      this.button = "submit-button"
      this.isSubmitting = false
      document.body.style.cursor = 'default';
    }
  },
  computed: {
    token() {
      return localStorage.getItem('Token')
    }
  },
  created() {
    if (this.token !== null) {
      this.$router.push("/home-page")
    } else {
      this.$store.dispatch("cleanStore")
    }
  }
};

</script>

<style scoped>
@import url('https://fonts.googleapis.com/css?family=Poppins:400,500,600,700&display=swap');
*{
  margin: 0;
  padding: 0;
  user-select: none;
  box-sizing: border-box;
  font-family: 'Poppins', sans-serif;
}

.login-page {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 58px 14px 20px;
  background:
    radial-gradient(circle at 10% 12%, rgba(120, 184, 67, 0.18), rgba(120, 184, 67, 0) 35%),
    radial-gradient(circle at 88% 88%, rgba(27, 66, 56, 0.12), rgba(27, 66, 56, 0) 30%),
    linear-gradient(180deg, #eceff3 0%, #e5e8ec 100%);
}

.alert{
  background: #ee5252;
  padding: 14px 38px 14px 0;
  min-width: 310px;
  position: fixed;
  top: 16px;
  right: 16px;
  border-radius: 10px;
  border-left: 8px solid #e22e2e;
  overflow: hidden;
  opacity: 0;
  pointer-events: none;
}
.alert.showAlert{
  opacity: 1;
  pointer-events: auto;
}
.alert.show{
  animation: show_slide 1s ease forwards;
}
@keyframes show_slide {
  0%{
    transform: translateX(100%);
  }
  40%{
    transform: translateX(-10%);
  }
  80%{
    transform: translateX(0%);
  }
  100%{
    transform: translateX(-10px);
  }
}
.alert.hide{
  animation: hide_slide 1s ease forwards;
}
@keyframes hide_slide {
  0%{
    transform: translateX(-10px);
  }
  40%{
    transform: translateX(0%);
  }
  80%{
    transform: translateX(-10%);
  }
  100%{
    transform: translateX(100%);
  }
}
.alert .msg{
  padding: 0 20px;
  font-size: 15px;
  font-weight: 600;
  color: #ffffff;
}
.alert .close-btn{
  position: absolute;
  right: 0px;
  top: 50%;
  transform: translateY(-50%);
  background: #e63232;
  padding: 14px 12px;
  cursor: pointer;
}
.alert .close-btn:hover{
  background: #d41c1c;
}
.alert .close-btn .fas{
  color:#8a1515;
  font-size: 18px;
  line-height: 28px;
}

.login {
  background: #ffffff;
  border-radius: 14px;
  width: min(520px, 100%);
  border: 1px solid #e3e7eb;
  box-shadow: 0 20px 44px rgba(0, 0, 0, 0.14);
  overflow: hidden;
}

.login-header {
  background: #78b843;
  background-image: url("../assets/login-fundo.png");
  background-size: cover;
  border-radius: 14px 14px 0 0;
  padding: 34px 0;
}

.login-header img {
  display: block;
  margin: 0 auto;
  padding: 14px;
  width: min(320px, 90%);
}

.login-icone {
  padding: 0 20px;
  margin-top: -48px;
}

.login-form {
  padding: 16px 20px 28px 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.login input[type="text"],
.login input[type="password"] {
  background: #f3f5f7;
  border: solid 1px #dbe1e7;
  padding: 15px 16px;
  width: 100%;
  font-size: 16px;
  color: #51565b;
  border-radius: 8px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;
}

.login input[type="text"]:focus,
.login input[type="password"]:focus {
  outline: none;
  border-color: #78b843;
  box-shadow: 0 0 0 3px rgba(120, 184, 67, 0.2);
  background-color: #fff;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
  border: solid 1px #eaeaea;
  font-size: 16px !important;
  color: #656464;
  -webkit-text-fill-color: #656464;
  -webkit-box-shadow: 0 0 0px 1000px #f2f4f6 inset;
  box-shadow: 0 0 0px 1000px #f2f4f6 inset;
}

.submit-button {
  background: linear-gradient(135deg, #7fbe47 0%, #69ab35 100%);
  color: #fff;
  border: none;
  font-size: 30px;
  font-size: 17px;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  padding: 14px 20px;
  border-radius: 8px;
  margin-top: 12px;
  cursor: pointer;
  align-self: flex-start;
  min-width: 132px;
  transition: transform 0.18s ease, box-shadow 0.2s ease, filter 0.2s ease;
}

.submit-button:hover {
  filter: brightness(1.03);
  box-shadow: 0 10px 20px rgba(96, 160, 52, 0.25);
  transform: translateY(-1px);
}

.submit-button-disable {
  background: #b8b8b8;
  color: rgb(255, 255, 255);
  border: none;
  font-size: 17px;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  padding: 14px 20px;
  border-radius: 8px;
  margin-top: 12px;
  cursor: not-allowed;
  outline: none;
  align-self: flex-start;
  min-width: 132px;
}

.button-loading {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.button-spinner {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.35);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: button-spin 0.8s linear infinite;
}

@keyframes button-spin {
  to {
    transform: rotate(360deg);
  }
}

.login-esqueci-senha {
  padding: 0 20px 25px 20px;
}

.login-esqueci-senha p {
  float: left;
}

.login-esqueci-senha p:nth-child(1) {
  padding-right: 10px;
}

.login-esqueci-senha a {
  color: #6b6c6c;
  font-weight: 300;
  text-decoration: none;
}

.login-esqueci-senha a:hover {
  text-decoration: underline;
}

@media screen and (max-width: 1199px) {
  .login {
    width: min(520px, 100%);
  }
}

@media screen and (min-width: 1201px) {
  .login {
    width: min(520px, 100%);
  }
}

@media screen and (max-width: 991px) {
  .login {
    width: min(520px, 100%);
  }
}

@media screen and (max-width: 767px) {
  .login {
    width: 80%;
  }
}

@media screen and (max-width: 576px) {
  .login {
    width: 100%;
  }

  .login-form {
    padding: 14px 14px 22px 14px;
  }

  .login-page {
    padding-top: 32px;
  }
}

</style>
